"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/subscribeSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeSixSubscribeSectionGeneratedProps = {
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "Subscribe Newsletter" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div0Div0Div1Div0Form0FormVisible?: boolean;
    sectionDiv0Div0Div0Div1Div0Form0FormRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0Form0FormProps?: Partial<ComponentProps<"form">>;
    sectionDiv0Div0Div0Div1Div0Form0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div1Div0Form0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0Form0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Enter Email Address" */
    sectionDiv0Div0Div0Div1Div0Form0Input0InputPlaceholder?: string;
};

const HomeSixSubscribeSectionGenerated: FC<HomeSixSubscribeSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0H20H2Text = "Subscribe Newsletter",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div1Div0Form0Input0InputPlaceholder = "Enter Email Address",
    sectionDiv0Div0Div0Div1Div0Form0Button0ButtonVisible,
    sectionDiv0Div0Div0Div1Div0Form0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div1Div0Form0Button0ButtonProps,
    sectionDiv0Div0Div0Div1Div0Form0FormVisible,
    sectionDiv0Div0Div0Div1Div0Form0FormRenderer,
    sectionDiv0Div0Div0Div1Div0Form0FormProps,
    sectionDiv0Div0Div0ClassName,
}) => {
    return (
        <section className="subscribe-section-six">
            <div className="container">
                <div className="subscribe-item-six">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row g-4"}>
                        <div className="col-lg-6">
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0H20H2Text}</h2>
                            ))}
                        </div>
                        <div className="col-lg-6">
                            <div className="subscribe-input">
                                {renderNode(sectionDiv0Div0Div0Div1Div0Form0FormVisible, sectionDiv0Div0Div0Div1Div0Form0FormRenderer, (
                                    <form action="#" className="flex-grow-1" {...(sectionDiv0Div0Div0Div1Div0Form0FormProps ?? {})}>
                                        <input type="email" className="form-control" placeholder={sectionDiv0Div0Div0Div1Div0Form0Input0InputPlaceholder} />
                                        {renderNode(sectionDiv0Div0Div0Div1Div0Form0Button0ButtonVisible, sectionDiv0Div0Div0Div1Div0Form0Button0ButtonRenderer, (
                                            <button type="submit" className="btn-icon btn btn-secondary" {...(sectionDiv0Div0Div0Div1Div0Form0Button0ButtonProps ?? {})}>
                                                <i className="isax isax-arrow-right-1" />
                                            </button>
                                        ))}
                                    </form>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeSixSubscribeSectionGenerated;
